var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0883 2.1245C17.1823 2.1705 19.9323 3.4825 21.2753 4.1235C21.7188 4.335 22.0003 4.782 22.0003 5.273V18.703C22.0003 19.1935 21.7208 19.64 21.2788 19.8525C20.0048 20.4665 17.4733 21.6855 17.3048 21.7655C17.1808 21.8245 16.8548 22 16.5908 22C16.2518 22 16.0243 21.842 15.8008 21.635L17.0003 17.8555V2.8575L15.8733 2.29C16.1143 2.0545 16.4483 2 16.6458 2C16.8268 2 16.9743 2.069 17.0883 2.1245Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50069 16.9481L17.0007 7.43663V2.91513C17.0007 2.26563 16.1697 2.01113 15.8322 2.32313C15.5047 2.62513 2.32969 14.6196 2.32969 14.6196C1.87969 15.0346 1.90519 15.7531 2.38319 16.1356C2.38319 16.1356 3.04519 16.7516 3.28469 16.9226C3.65269 17.1851 4.13619 17.2151 4.50069 16.9481Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50069 7.05208L17.0007 16.5791V20.9646C17.0007 21.5636 16.2907 22.0611 15.8012 21.6351L2.32969 9.38058C1.87969 8.96558 1.90519 8.24708 2.38319 7.86458C2.38319 7.86458 3.04519 7.24858 3.28469 7.07758C3.65269 6.81508 4.13619 6.78508 4.50069 7.05208Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.ddc20d5ebc149e931a3fff65d8c66cda.svg";
export { ForwardRef as ReactComponent };